import React from 'react'
import MarkdownMessage from '@gluedigital/markdown-message'
import { CellCompProps } from '../Table'

const MarkdownCell = <T extends {}> ({ row, col }: CellCompProps<T>) => {
  const val = row[col.name]
  return (
    <div title={val} className={`cell ${col.name}`}>
      <MarkdownMessage id={`formatted-cell.${val}`} />
    </div>
  )
}

export default MarkdownCell
